import { render } from "./Observer.vue?vue&type=template&id=84b57dca"
import script from "./Observer.vue?vue&type=script&lang=js"
export * from "./Observer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__